const FormResources = {

    form_data:{
        associate_id:   '',
        time_off_id:    '',
        start_date:     '',
        end_date:       '',
        hours:          0,
        reason:         '',
    },

    form_format:[
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Time off:',
            model_name: 'time_off_id',
            ref:        'time_off_id_input',
            ref_alt:    'time_off_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'date',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Start date:',
            model_name: 'start_date',
            ref:        'start_date_input',
            ref_alt:    'start_date_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'date',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'End date:',
            model_name: 'end_date',
            ref:        'end_date_input',
            ref_alt:    'end_date_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Hours:',
            model_name: 'hours',
            ref:        'hours_input',
            ref_alt:    'hours_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-12',
            type:       'text',
            maxlength:  100,
            disabled:   false,
            step:       '',
            name:       'Reason:',
            model_name: 'reason',
            ref:        'reason_input',
            ref_alt:    'reason_input_alt',
            required:   false,
        },
    ]

}

export default FormResources;